import { useCallback, useState } from 'react';

import { TModal } from '@widgets/MyTeam/model/types';

export const useChangeCurrentModal = () => {
    const [currentModal, setCurrentModal] = useState<TModal>(null);
    const [currentClickedId, setCurrentClickedId] = useState<number | null>(null);

    const onChangeCurrentModal = useCallback(
        (value: TModal) => {
            setCurrentModal(value);
        },
        [setCurrentModal]
    );
    const onCloseCurrentModal = useCallback(() => {
        setCurrentModal(null);
    }, [setCurrentModal]);
    const onChangeCurrentClickedId = (clickedId: number | null) => {
        setCurrentClickedId(clickedId);
    };

    return {
        currentModal,
        currentClickedId,
        onChangeCurrentModal,
        onCloseCurrentModal,
        onChangeCurrentClickedId,
    };
};
